import React from "react";
import { Link } from "react-router-dom";
import "../components/about.css";
import CTA from "../components/cta";
function Sales()
{
    return(
       <>
   <section
              className="flat-title-page innerbanner mrg-0 boder-r-0 pdg-btm-60"
              style={{ backgroundImage: "url(images/inner-banner/Sales.jpg)" }}
            >
              <div className="container">
                <div className="breadcrumb-content">
                  <h1 className="text-center text-white title">Sales</h1>
                  <ul className="breadcrumb">
                    <li>
                      <Link to="/" className="text-white">
                        Home
                      </Link>
                    </li>
                    <li className="text-white">/ Services</li>
                    <li className="text-white">/ Sales</li>
                  </ul>
                </div>
              </div>
            </section> 
  <section className="flat-section agnts">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="content-left img-animation wow">
          <img
            className="lazyload"
            src="assets/images/f3q3.webp"
            alt=""
            style={{ borderRadius: 10 }}
          />
        </div>
        <div className="content-right">
          <div className="box-title wow fadeInUp">
            <div className="text-subtitle text-primary">Services</div>
            <h3 className="title mt-4">
              {" "}
              Expert Property Sales Services UAE for Your Real Estate Success.
              Your Trusted Partner in the UAE Market
            </h3>
            <p className="desc">
              Buying or selling a home is a very big decision for any person or
              family. You need a professional team that knows the local laws and
              market trends perfectly. Nova Vision Real Estate provides top
              Property Sales services UAE to help you succeed. We guide you
              through every single step of the journey with total honesty and
              care. Our team makes the complex process feel very simple and safe
              for every client. We work hard to ensure you get the best value
              for your important investment.
            </p>
            <h3 className="title mt-4">
              {" "}
              Why Choose Nova Vision for Your Sale?
            </h3>
            <p className="desc">
              Our experts have many years of experience working in Dubai and Abu
              Dhabi. We use the latest market reports to find the most accurate
              price for your home. We handle everything from finding buyers to
              managing the legal transfer paperwork. Our main goal is to make
              your property journey stress-free and highly profitable. Here is
              what our expert team does to help you sell your property:
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="flat-section agnts">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="content-right">
          <div className="box-title wow fadeInUp">
            <ul>
              <li>
                • Provide accurate property valuations using the latest official
                market data.
              </li>
              <li>
                • Create high-quality listings and photos to attract many
                serious buyers quickly.
              </li>
              <li>
                • Handle all negotiations to get you the best possible price for
                your asset.
              </li>
              <li>
                • Manage the final ownership transfer at the Land Department
                office safely.
              </li>
            </ul>
            <h3 className="title mt-4">
              {" "}
              Safe and Legal Real Estate Transactions
            </h3>
            <p className="desc">
              Trust is the most important part of our relationship with every
              client we serve. We ensure every deal follows the strict rules of
              RERA and the Land Department. For off-plan sales, we ensure your
              money stays safe in regulated Escrow accounts. This special system
              protects your money until the building project is actually
              finished. You also benefit from zero capital gains tax when
              selling property in the UAE. This means you keep all the profit
              from your successful sale for yourself.
            </p>
            <h3 className="title mt-4"> Start Your Property Journey Today</h3>
            <p className="desc">
              Are you ready to sell or buy a home in the United Arab Emirates?
              Contact Nova Vision Real Estate today for a free consultation with
              our experts. Our professional Property Sales services UAE are
              designed to help you reach your goals. We turn your real estate
              dreams into a happy reality every single day.
            </p>
          </div>
        </div>
        <div className="content-left img-animation wow">
          <img
            className="lazyload"
            src="assets/images/iuyrtr.webp"
            alt=""
            style={{ borderRadius: 10 }}
          />
        </div>
      </div>
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default Sales;